// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const ReportSectionOut = zod.object({
  "key": zod.string(),
  "markdown": zod.string(),
  "title": zod.string()
});

export type ReportSectionOut = zod.input<typeof ReportSectionOut>;
export type ReportSectionOutOutput = zod.output<typeof ReportSectionOut>;
